import { render, staticRenderFns } from "./MailText.vue?vue&type=template&id=fa0d9a34&scoped=true"
var script = {}
import style0 from "./MailText.vue?vue&type=style&index=0&id=fa0d9a34&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa0d9a34",
  null
  
)

export default component.exports